import { IProduct } from '@models/IProduct';
import { IProductListing, ListingProductType } from '@models/IProductListing';
import ListingCardTypeEnum from '@models/enums/ListingCardTypeEnum';
import ListingResultsContainer from '@molecules/ListingResultsContainer/ListingResultsContainer';
import ListingTopBar from '@molecules/ListingTopBar/ListingTopBar';
import LoadMoreListing from '@molecules/LoadMoreListing/LoadMoreListing';
import SoftLoadWrapper from '@molecules/SoftLoadWrapper/SoftLoadWrapper';
import useListingComponentProps from '@utils/hooks/useListingComponentProps';
import ProductListingCardBlock from './ProductListingCardBlock';

const ProductListing = (props: IProductListing) => {
  const {
    productCategory,
    productListingName,
    productSubCategory,
    statusLabels,
    showExpandedFilters,
    listingId = '',
  } = props;
  const preFilterParams = {
    ListingId: [listingId],
    ProductCategoryList: [productCategory],
    ProductSubCategoryList: [productSubCategory],
  };
  const { results, ...listingProps } = useListingComponentProps({
    ...props,
    preFilterParams,
  });

  const filteredProductResults = results.filter(
    (result) =>
      (result as ListingProductType).type === ListingCardTypeEnum.Product
  );

  return (
    <section className="component-padding bg-black-100 pt-7.5 text-white lg:pt-24">
      <SoftLoadWrapper>
        <div className="container">
          <ListingTopBar
            {...listingProps}
            pageType="ProductListing"
            showExpandedFilters={showExpandedFilters}
          />
        </div>

        <div className="flex flex-col gap-y-8 md:gap-y-20">
          <ListingResultsContainer
            results={results}
            {...listingProps}
            loadingBackgroundClassName="bg-black-100/60"
            noResultsClassName="container"
            errorClassName="container"
          >
            <ProductListingCardBlock
              productListingName={productListingName}
              statusLabels={statusLabels}
              results={results as ListingProductType[]}
              {...listingProps}
            />
          </ListingResultsContainer>
        </div>

        <LoadMoreListing
          results={filteredProductResults as IProduct[]}
          {...listingProps}
        />
      </SoftLoadWrapper>
    </section>
  );
};

export default ProductListing;
